import React, { memo } from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header/Header";

const Layout = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="mx-auto w-full ">
        <Outlet />
      </main>
      {/* <Footer /> */}
    </div>
  );
};

export default memo(Layout);
